<script>
export default {
    name: "LPOPrint",

    data() {
        return {
            purchaseOrder: {},
            lpoLines: []
        };
    },

    mounted() {

        this.fetchLPO().then(() => {
            this.fetchLPOItems().then(() => {
                window.print();
            });
        });
    },
    computed: {

total() {

    if(!this.lpoLines.length) return 0;

    return this.lpoLines.map(item => item.grandTotal ? parseFloat(item.grandTotal) : 0)
        .reduce((sum, amt) => sum +amt);
},
},
    methods: {

        fetchLPO() {
            let url = `SupplierLPO/PostedSpecificLPO`;
                url += `?LPONo=${this.$route.params.LPONo}`;

            return this.$accountsHttp.get(url).then(({ data }) => {
                this.purchaseOrder = data.length ? data[0] : {};
            }).catch(() => {});
        },

        fetchLPOItems() {
            let url = `SupplierLPO/PostedSpecificLPODetails`;
                url += `?LPONo=${this.$route.params.LPONo}`;

            return this.$accountsHttp.get(url)
                .then(({ data }) => { this.lpoLines = data; }).catch(() => {});
        },
        parseInteger(val) {
            return parseInt(val);
        }
    },
}
</script>
<template>
    <div class="w-full">
        <tail-address-header></tail-address-header>
        <div class="flex justify-center p-2 my-2">
            <h3 class="text-center font-bold text-xl uppercase">Purchase Order</h3>
        </div>
        <div class="flex flex-row w-full p-1">
            <div class="flex-1">
                <h4 class="font-bold text-sm">Supplier: {{ purchaseOrder.supplier }}</h4>
            </div>
            <div class="flex-1">
                <h4 class="font-bold text-sm">Date: {{ purchaseOrder.date | dateFormat }}</h4>
            </div>
            <div class="flex-1">
                <h4 class="font-bold text-sm">LPO Ref:{{ purchaseOrder.lpO_No }}</h4>
            </div>
            <div class="flex-1">
                <h4 class="font-bold text-sm">Other Ref: {{ purchaseOrder.ref_No }}</h4>
            </div>
        </div>
        <div class="w-full">
            <table class="table text-sm">
                <thead>
                    <tr>
                        <th class="p-tiny">Item</th>
                        <th class="p-tiny">Description</th>
                        <th class="p-tiny">Qty</th>
                        <th class="p-tiny" 
                            v-if="parseInteger($route.query.price)">Unit Cost</th>
                        <th class="p-tiny" 
                            v-if="parseInteger($route.query.price)">Total</th>
                        <th class="p-tiny" 
                            v-if="parseInteger($route.query.price)">Grand total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(lpoLine, index) in lpoLines" :key="index">
                        <td class="p-tiny">{{ lpoLine.service }}</td>
                        <td class="p-tiny">{{ lpoLine.description }}</td>
                        <td class="p-tiny">{{ lpoLine.quantity | numberFormat }}</td>
                        <td class="p-tiny" 
                            v-if="parseInteger($route.query.price)">{{ lpoLine.charge | numberFormat }}</td>
                        <td class="p-tiny" 
                            v-if="parseInteger($route.query.price)">{{ lpoLine.total | numberFormat }}</td>
                        <td class="p-tiny" 
                            v-if="parseInteger($route.query.price)">{{ lpoLine.grandTotal | numberFormat }}</td>
                    </tr>
                    <tr>
                <td colspan="6" class="p-1 text-right" v-if="parseInteger($route.query.price)">
                    <h4 class="font-bold text-sm">  Grand Total: {{ total | numberFormat }}</h4>
                </td>
            </tr>
                </tbody>
            </table>
            <div class=" w-full"  v-if="$root.checkAuth('ViewLPOSignatories')">
            <div class="flex-1">
                <h4 class="font-bold text-sm">Prepared By: ____________________________________________________________ Signature:________________________ Date:________________________</h4>
            </div>
            <div class="flex-1 mt-2">
                <h4 class="font-bold text-sm">Approved By: ___________________________________________________________ Signature:________________________ Date:________________________</h4>
        
            </div><div class="flex-1 mt-2">
                <h4 class="font-bold text-sm">Certified By:_____________________________________________________________ Signature:________________________ Date:________________________</h4>
        
            </div>
            
        </div>
    </div>
    </div>
</template>
